<template>
  <div>    
    <div class="card p-4 md:p-8">
        <ReportsTable></ReportsTable>
    </div>
  </div>
</template>


<script>

import ReportsTable from './components/ReportsTable.vue'

export default {
  data () {
    return {}
  },

  components: {
    ReportsTable
  }

}
</script>


<style lang="scss" scoped>
  /deep/ .total {
    font-weight: 500 !important;
    font-size: 14px !important;
  }
  .card {
    background: #fff;
  }

  /deep/ .vue-treeselect__multi-value-label {
    max-width: 120px !important;
  }
</style>
